import React from "react";
import * as S from "./InputText.styles";

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
};

export default function InputText({ label, ...props }: InputProps) {
    const id = props.id || props.placeholder;
    return <S.Container>
        { label && <S.Label htmlFor={ id }>{ label }</S.Label> }
        <S.Input id={ id } {...props} />
    </S.Container>;
}
